<template>
  <div class="main">
    <a-spin class="load"
            v-show="loading" />
    <div class="top">
      <div class="title">
        <span class="t-l">写作指导</span>
        <span class="t-r flex-row">
          <div @click="goBeiKe()" style="margin:auto 5px auto 5px;"><span class="use-his">备课历史</span> </div>
          <a-divider type="vertical" style="margin:auto 5px auto 5px;" />
          <div @click="goZiYuan()" style="margin:auto 5px auto 5px;"><span class="pre">备课资源</span> </div>
          <span  @click="orderRelease" type="primary" class="has-ep">发布</span>
<!--          <span  @click="goStudent" type="primary" class="has-ep">学生端预览</span>-->
        </span>
      </div>
      <div class="left">
        <div class="content">
          <div class="bgc"
               v-for="(item,index) in listData"
               :key="index">
<!--            <div class="status">-->
<!--              <span class="staTitle">状态</span>-->
<!--              <span class="staMain">{{format.permission(item.permission)}}</span>-->
<!--            </div>-->
            <div class="prepare-content">
              <div class="title">
                {{item.title}}
              </div>
              <p class="text" v-html="item.guideContent"></p>
            </div>
<!--            <div class="caozuo">-->
<!--              <a-button class="edit"-->
<!--                        @click="edit(item)"-->
<!--                        icon="form">编辑</a-button>-->
<!--              <a-button class="delete"-->
<!--                        @click="deleted(item.id)"-->
<!--                        icon="delete">删除</a-button>-->
<!--            </div>-->

            <div class="task-status">
              <div class="status-l">
                <span class="staTitle">状态:</span>
                <span class="staMain">{{ format.permission(item.permission) }}</span>
              </div>
              <div class="status-r">
                <a-button class="edit" @click="edit(item)" icon="form">编辑</a-button>
                <a-button class="delete" @click="deleted(item.id)" icon="delete">删除</a-button>
              </div>
            </div>
          </div>
          <div class="bgc" v-if="listData.length==0">
            <a-empty style="padding:80px"/>
          </div>
          <div class="fun">
            <a-button class="add"
                      @click="add"
                      icon="plus">添加</a-button>
          </div>
        </div>
        <!-- <div class="book-attainment-content">
          <div class="attament-content-title">优秀范文</div>
          <p class="attament-content-knowledge"
            v-for="(item,index) in knowledges"
            :key="'index'+index" @click.self=goDetail()>
            <span>{{item.content}}</span>
            <img @click.stop="delHidden(item.id)"
                class="atament-content-knowledge-logo"
                src="@/assets/image/22.png" />
          </p>
          <div v-if="!knowledges||knowledges.length===0">
            <a-empty />
          </div>
        </div> -->
      <!-- <div class="deleteKnowledge">
      <div class="deleteCont">
        <div class="deleteTitle">已经隐藏的优秀范文</div>
        <div class="del">
          <p class="attament-content-knowledge"
              v-for="(item,index) in knowledgeDel"
              :key="index">
            <span>{{item.content}}</span>
            <img @click.stop="addHidden(item.id)"
                  class="atament-content-knowledge-logo"
                  src="@/assets/image/23.png" />
          </p>
        </div>
      </div>
    </div> -->
      </div>
<!--      <div class="right">-->
<!--        <div class="order">-->
<!--          <div class="studentLook">-->
<!--            <a-button class="orderMes"-->
<!--                      @click="orderRelease"-->
<!--                      type="primary">发布</a-button>-->
<!--            <a-tooltip placement="top" :title="tipMess">-->
<!--              <a-button class="studentView" type="primary" @click="goStudent"><img class="logo" src="@/assets/imgs/logo2.png" />学生端预览</a-button>-->
<!--            </a-tooltip>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="history">-->
<!--          <a-button class="resources"-->
<!--                    @click="goZiYuan()">备课资源</a-button>-->
<!--          <a-button class="classes"-->
<!--                    @click="goBeiKe()">备课历史</a-button>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <!--add start-->
    <a-modal v-model="addVisible"
            destroyOnClose
             title=""
             width="1000px"
             footer="">
      <div class="dalog">
        <div>
          <a-input v-model="addParam.title" placeholder="请输入标题..." />
        </div>
        <div>
          <wangeditor style="margin-top: 10px;"  @input="getInput" v-model="addParam.guideContent"></wangeditor>
        </div>
        <div class="uploadImg">
          <a-select default-value="私有"
                    style="width:170px;"
                    @change="addSelectChange">
            <a-select-option v-for="(item, index) in selectOpen"
                             :key="index"
                             :value="item.key">
              {{item.value}}
            </a-select-option>
          </a-select>
          <a-button class="sureButton"
                    @click="addHandleOk">确定</a-button>
        </div>
      </div>
    </a-modal>
    <!--add end-->
    <!--edit start-->
    <a-modal v-model="editVisible"
             destroyOnClose
             title=""
             width="1000px"
             footer="">
      <div class="editdalog">
        <div>
          <a-input v-model="editMess.title"
                   placeholder="请输入标题..."
                   @change="editTitleChange" />
        </div>
        <div>
          <wangeditor style="margin-top:10px;" @input="getInput" v-model="guideContent"></wangeditor>
        </div>
        <div class="uploadImg">
          <a-select style="width:170px;"
                    :default-value="format.viewPermission(editMess.permission)"
                    @change="editSelectChange">
            <a-select-option v-for="(item, index) in selectOpen"
                             :key="index"
                             :value="item.key">
              <!-- {{format.viewPermission(editMess.viewPermission)}} -->
              {{item.value}}
            </a-select-option>
          </a-select>
          <a-button class="sureButton"
                    @click="editHandleOk(editMess)">确定</a-button>
        </div>
      </div>
    </a-modal>
    <!--edit end-->
    <a-modal class="classNumber"
             v-model="release"
             width="440px"
             title=""
             footer="">
      <div class="classTop">
        <a-checkbox-group @change="checkClass">
          <div class="classSelect"
               v-for="(item, index) in classData"
               :key="index">
            <a-checkbox :value="item.id">{{item.className}}</a-checkbox>
          </div>
        </a-checkbox-group>
        <div class="classBot">
          <a-button class="cancelButton"
                    @click="release = false">取消</a-button>
          <a-button class="classSureButton"
                    :disabled="disabledClass ==false"
                    @click="classSure">确定</a-button>
        </div>
      </div>
    </a-modal>
    <!---学生端预览弹窗--->
    <a-modal class="classNumber" v-model="releaseStu" width="440px" title="" footer="">
      <div class="classTop">
        <a-radio-group  @change="onChangeStu">
          <div class="classSelect" v-for="(item, index) in classData" :key="index">
            <a-radio :value="item.id">{{item.className}}</a-radio>
          </div>
        </a-radio-group>
        <div class="classBot">
          <a-button class="cancelButton" @click="releaseStu = false">取消</a-button>
          <a-button class="classSureButton" @click="classSureStu">确定</a-button>
        </div>
      </div>
    </a-modal>
    <!---学生端预览结束弹窗--->
    <a-modal title="提示"
             :visible="visible"
             :confirm-loading="confirmLoading"
             @ok="handleOk"
             @cancel="handleCancel">
      <p>{{ ModalText }}</p>
    </a-modal>
    <a-modal v-model="delVisible"
             title="删除"
             @ok="delOk">
      <p>删除后将不可恢复您确认要删除吗？</p>
    </a-modal>
    <div v-if="lookVis">
      <a-modal class="classNumber" v-model="lookVis" width="440px" title="" footer="">
        <div class="classTop">
          <a-radio-group @change="lookCheckClass">
            <div class="classSelect" v-for="(item, index) in classData" :key="index">
              <a-radio :value="item.id">{{item.className}}</a-radio>
            </div>
          </a-radio-group>
          <div class="classBot">
            <a-button class="cancelButton" @click="lookVis = false">取消</a-button>
            <a-button class="classSureButton" @click="lookSure">确定</a-button>
          </div>
        </div>
      </a-modal>
    </div>
    <a-modal title="预览" class="classNumber" v-model="look" width="1100px" @cancel="()=>{look = false}" footer="">
      <div class="view-mess">
        <div class="view-detail" v-for="(item,index) in viewMess" :key="index" v-html="item.guideContent"></div>
      </div>
      <div v-if="viewMess==null||viewMess.length==0">
        <a-empty style="margin-top:80px"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
// import HanIcon from 'components/Icon.vue'
import format from '../../../utils/format.js'
import wangeditor from '@/components/Wangeditor.vue'
export default {
  name: 'WritingGuide',
  components: {
    wangeditor
  },
  created () {

  },
  data () {
    return {
      delVisible: false, // 删除
      visible: false,
      confirmLoading: false,
      ModalText: '请先添加活动',
      format,
      disable: false,
      loading: false,
      listData: [],
      defaultOpen: '公开',
      selectOpen: [{ value: '私有', key: '2' }, { value: '公开', key: '1' }],
      addVisible: false,
      editVisible: false,
      status: '公开',
      title: '', // addTitle
      editTitle: '', // editTitle
      addMessage: '', // 添加信息
      addSelect: '', // 添加类型
      editMess: '', // 编辑信息对象
      editDefault: '',
      editMessage: '', // 编辑信息详情
      editSelect: '', // 编辑信息选择
      id: '',
      classData: [], // 班级信息列表
      orderParam: [], // 选择的发布班级
      releaseStu: false, // 发布到学生生端弹窗
      disabledClass: false,
      release: false, // 发布
      guideContent:'',
      addParam: {
        bookId: localStorage.getItem('syzg-bookId'),
        styleId: localStorage.getItem('styleId'),
        guideContent: '',
        title: '',
        teacherId: this.$getUserInfo().id,
        permission: '2',
        school: ''
      },
      delParam: { id: '' },
      knowledges: [],
      knowledgeDel: [],
      ability: '',
      loading: false,
      look: false,
      lookVis: false,
      lookClassData: '',
      viewMess:[],
      tipMess: '请您发布成功后再预览！'
    }
  },
  watch: {
    mlVisible () {

    }
  },
  mounted () {
    this.getData()
    this.getClassNum()
    this.getRecommandList()
  },
  methods: {
    goStudent(){
      this.lookVis = true
    },
    lookCheckClass(val){
      this.lookClassData = val.target.value
    },
    lookSure(){
      if(this.lookClassData==''){
        this.$message.warning('请选择要预览的班级')
      }else{
        const param = {
        styleId: localStorage.getItem('styleId'),
        userId: this.$getUserInfo().id,
        classId: this.lookClassData
      }
      const _this = this
      this.$fetch({
          url: _this.$baseUrl + 'ebook/teacher/guide/getTeacherWritingGuidePreview',
          body: param
      }).loading(
          () => (_this.loading = true),
          () => (_this.loading = false)
        ).done(res => {
          if(res&&res.success){
            _this.$nextTick(()=>{
              _this.viewMess = res.resultData
              _this.lookVis = false
              _this.look = true
            })
          }
        })
      }
    },
    getInput(val){
      this.editMessage = val
    },
    getData () {
      const param = {
        bookId: localStorage.getItem('syzg-bookId'),
        styleId: localStorage.getItem('styleId'),
        teacherId: this.$getUserInfo().id,
        isPublish: '0'
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/guide/getTeacherWritingGuide',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listData = res.resultData
        }
      })
    },
    add () { // 新增弹窗
      this.addVisible = true
      this.addParam.guideContent = ''
      this.addParam.title = ''
      this.addParam.permission = '2'
    },
    addSelectChange (val) { // 新增权限选择
      this.addParam.permission = val
    },
    addHandleOk () { // 新增保存
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/guide/saveWritingGuide',
        body: this.addParam
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('新增成功')
          this.addVisible = false
        }
        this.getData()
      })
    },
    edit (item) { // 编辑弹窗
      this.editMess = ''
      this.editMess = item
      this.id = item.id
      this.editVisible = true
      this.editSelect = this.editMess.permission
      this.guideContent = item.guideContent
    },
    editTitleChange (val) {
      this.editTitle = val.target.value
    },
    editSelectChange (val) { // 编辑权限选择
      this.editSelect = val
    },
    textChange (val) {
      this.editMessage = val.target.value
    },
    editHandleOk (editMess) {
      const param = {
        id: editMess.id,
        bookId: editMess.bookId,
        school: editMess.school,
        styleId: editMess.styleId,
        paragraphId: '',
        sentenceId: '',
        guideContent: this.guideContent,
        title: this.editMess.title,
        teacherId: this.$getUserInfo().id,
        permission: this.editSelect,
        publish: ''
        // rangeType: '5'
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/guide/saveWritingGuide',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('编辑成功')
          this.editVisible = false
        }
        this.getData()
      })
    },
    delOk () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/guide/deleteWritingGuide',
        body: this.delParam
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('删除成功')
          this.delVisible = false
        }
        this.getData()
      })
    },
    deleted (id) {
      this.delVisible = true
      this.delParam.id = id
    },
    goZiYuan () { // 跳转资源推荐
      this.$router.push({ path: '/books/writingRecommend/' })
    },
    goBeiKe () { // 跳转历史
      this.$router.push({ path: '/books/writingHistory/' })
    },
    orderRelease () { // 发布
      if (this.classData != null && this.classData.length > 0) {
        this.release = true
      } else {
        this.$message.warning('暂无发布班级信息')
      }
    },
    checkClass (val) {
      this.orderParam = val
      if (this.orderParam.length > 0) {
        this.disabledClass = true
      } else {
        this.disabledClass = false
      }
    },
    getClassNum () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/v3/common/getSimpleClaList',
        body: { userId: this.$getUserInfo().id }
      }).done(res => {
        if (res && res.success && res.resultCode === '0') {
          this.classData = res.resultData
        }
      })
    },
    handleOk (e) {
      this.visible = false
      this.confirmLoading = false
    },
    handleCancel (e) {
      this.visible = false
    },
    classSure () {
      const param = {
        styleId: localStorage.getItem('styleId'),
        teacherId: this.$getUserInfo().id,
        classIds: this.orderParam
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/push/publishToClass',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('发布成功')
          this.release = false
        } else {
          this.$message.error(res.resultMessage)
        }
      })
    },
    onChangeStu (e) { // 发布学生端班级筛选
      this.classStuId = e.target.value
    },
    classSureStu () { // 确定发布到学生端
      if (!this.classStuId) {
        this.$message.warning('请您选择班级预览')
        return false
      } else {
        this.releaseStu = false
        //window.open(this.$studentUrl + '#/books/writing-guide/' + localStorage.getItem('styleId'))
      }
    },
    getRecommandList () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/keyPoint/getTeacherKeyPoint',
        body: {
          styleId: localStorage.getItem('styleId')
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.knowledges = res.resultData.keyKnowledgeShow
        this.ability = res.resultData.keyAbilityList
        this.knowledgeDel = res.resultData.keyKnowledgeHidden
      })
    },
    // 隐藏单挑
    delHidden (id) {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/keyPoint/deleteUserKeyKnowledge',
        body: {
          styleId: localStorage.getItem('styleId'),
          id: id
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.$message.success('隐藏成功')
        this.getRecommandList()
      })
    },
    // 显示隐藏
    addHidden (id) {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/keyPoint/addUserKeyKnowledge',
        body: {
          styleId: localStorage.getItem('styleId'),
          id: id
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.$message.success('显示成功')
        this.getRecommandList()
      })
    },
    goDetail () {
      this.$router.push({ name: 'WritingGuideDetail' })
    }
  }
}
</script>
<style lang="less" scoped>
.main {
 // width: 1240px;
  padding-right: 0px;
  margin: 0px 20px;
  border-radius: 12px;
  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }
  .top {
    // height:400px;
   // display: flex;
    background: #fff;
    padding: 20px 30px 20px 30px;
    margin-top: 20px;
    border-radius: 12px;
    height: calc(100vh - 185px);
    // max-height: 600px;
    overflow-y: auto;

    .title{
      display: flex;
      margin: 0 auto 0px auto;
      .t-l{
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }
      .t-r{
        margin-left: auto;
        align-content: center;
        text-align: center;
        font-size: 14px;
        color: #d7d7d7;
        .use-his{
          color: @primary-color;
          cursor: pointer;
          // margin-right: 15px;
          text-align: center;
        }
        .pre{
          color: @primary-color;
          cursor: pointer;
          text-align: center;
          width: 4.45vw;
          height: 1.67vw;
        }
        .has-ep {
          width: 80px;
          text-align: center;
          line-height: 24px;
          background: @primary-color;
          border-radius: 2px;
          border: 1px solid @primary-color;
          color: #fff;
          margin-left: 20px;
        }
        .add-pre{
          display: inline-block;
          width: 80px;
          height: 24px;
          line-height: 24px;
          background: @primary-color;
          border-radius: 2px;
          color: #fff;
          text-align: center;
          margin-left: 20px;
          cursor: pointer;
          .add-img{
            width: 16px;
            height: 16px;
          }
          .add-text{
            margin-left: 5px;
          }
        }
      }
    }
    .left {
      flex: 20;
      border-radius: 12px;
      min-height: 400px;
      .content {
        width: 100%;
        //max-height: 500px;
        overflow-y: auto;
        .bgc {
          background: #F1F0F0;
          min-height: 350px;
          border-radius: 12px;
          margin-top: 20px;

          .prepare-content {
            .title {
              margin: 20px 20px 0px 20px;
              padding-left: 1em;
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #000;
              // height: 60px;
              line-height: 60px;
             // background-color: #f8f8f8;
              border-radius: 8px;
            }
            .text {
              padding: 10px 15px;
               border-radius: 8px;
            //  background-color: #f8f8f8;
              margin: 20px 20px 20px;
             // min-height: 160px;
             // height:160px;
             // overflow:scroll;
            }
            margin-top: 15px;
            width: 100%;
            height: 100%;
            //background-color: white;
            border-radius: @border-radius-base;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #040506;
            white-space: pre-wrap;
            font-weight: normal;
            font-stretch: normal;
          }
          .status {
            padding: 20px 20px 0px 20px;
            .staTitle {
              font-size: 22px;
              color: #bdbdbd;
            }
            .staMain {
              font-size: 22px;
              color: #000;
              margin-left: 30px;
            }
          }
          .message {
            //background: #f8f8f8;
            margin: 0 50px;
            color: #000;
            font-size: 16px;
            letter-spacing: 0px;
            padding: 15px 16px;
            line-height: 30px;
            font-weight: normal;
            margin-top: 12px;
          }

          .task-status {
            //text-align: right;
            //height: 60px;
            //line-height: 60px;
            display: flex;
            border-top: 1px solid #DBDBDB;
            padding-top: 20px;
            padding-bottom: 20px;
            padding-right: 20px;

            .status-l {
              font-size: 14px;
              margin-left: 20px;
              .staTitle {
                font-size: 14px;
                color: #867D7BFF;
              }

              .staMain {
                font-size: 14px;
                color: @primary-color;
                margin-left: 10px;
              }
            }
            .status-r {
              margin-left: auto;
              span {
                color: @primary-color;
                cursor: pointer;
                display: inline-block;
                width: 80px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                border-radius: 2px;
                border: 1px solid @primary-color;
                margin-left: 8px;
              }
              .no-e{
                width: 80px;
                text-align: center;
                line-height: 24px;
                background: #F1F0F0;
                border-radius: 2px;
                border: 1px solid #bdbdbd;
                color: #bdbdbd;
              }
              .has-e{
                width: 80px;
                text-align: center;
                line-height: 24px;
                background: #F1F0F0;
                border-radius: 2px;
                border: 1px solid @primary-color;
                color: @primary-color;
              }
              .studentView {
                width: 120px;
                height: 40px;
                border-radius: 8px;
                margin-top: 20px;
                margin-left: -30px;
                background: #f8f8f8;
                color: #000;
                border: none;

                .logo {
                  width: 20px;
                  height: 20px;
                  margin-top: -4px;
                  margin-right: 8px;
                  margin-left: -10px;
                }
              }
            }

            .operate{
              text-align: right;
            }

            .status {
              padding: 20px 20px 0px 20px;

              .staTitle {
                font-size: 14px;
                color: #867D7BFF;
              }

              .staMain {
                font-size: 14px;
                color: @primary-color;
                margin-left: 10px;
              }
            }
            .edit {
              width: 80px;
              text-align: center;
              line-height: 24px;
              background: #F1F0F0;
              border-radius: 2px;
              border: 1px solid @primary-color;
              color: @primary-color;
              margin-right: 20px;
            }

            .delete {
              width: 80px;
              text-align: center;
              line-height: 24px;
              background: #F1F0F0;
              border-radius: 2px;
              border: 1px solid #fa5542;
              color: #db5647;
            }
          }
        }
      }
      .book-attainment-content {
        border-radius: @border-radius-base;
        background-color: @white;
        flex: 20;
        margin-top: 30px;
        padding-left: 50px;
        padding-bottom: 55px;
        padding-right: 50px;
        .back-Btn {
          display: inline-block;
          justify-content: left;
          align-items: center;
          cursor: pointer;
          font-size: 20px;
          color: #dbd1cd;
          font-family: "PingFangSC-Semibold";
          height: 30px;
          .back-Icon {
            height: 19px;
            position: relative;
            right: 10px;
          }
        }
        .back-Btn:hover {
          color: @primary-color;
        }
        .attament-content-title {
          margin: 30px auto;
          height: 45px;
          width: 220px;
          text-align: center;
          line-height: 38px;
          font-family: "PingFangSC-Regular";
          color: #000000;
          font-size: 20px;
          // font-weight: normal;
        }
        .attament-content-knowledge {
          display: flex;
          position: relative;
          width: 100%;
          height: 60px;
          background-color: #f8f8f8;
          align-items: center;
          font-size: 20px;
          border-radius: 8px;
          font-family: "STSongti-SC-Regular";
          .atament-content-knowledge-logo {
            cursor: pointer;
            width: 30px;
            height: 30px;
            position: absolute;
            right: 20px;
          }
          span {
            padding-left: 20px;
            font-size: 20px;
          }
        }
        .attament-content-ability {
          font-size: 20px;
          font-family: "STSongti-SC-Regular";
        }
      }
      .deleteKnowledge {
        width: 1240px;
        display: flex;
        margin: 0 auto;
        // height: 100px;
        margin-top: 20px;
        background: #fff;
        margin-bottom: 50px;
        border-radius: 8px;
        .deleteCont {
          flex: 24;
          border-radius: 12px;
          height: auto;
          .deleteTitle {
            text-align: center;
            color: #9d9292;
            font-size: 16px;
            margin-top: 30px;
          }
          .del {
            padding: 0 50px;
            margin-top: 30px;
            .attament-content-knowledge {
              display: flex;
              position: relative;
              width: 100%;
              height: 60px;
              background-color: #f8f8f8;
              align-items: center;
              font-size: 20px;
              border-radius: 8px;
              font-family: "STSongti-SC-Regular";
              .atament-content-knowledge-logo {
                width: 30px;
                height: 30px;
                position: absolute;
                right: 20px;
                cursor: pointer;
              }
              span {
                padding-left: 20px;
                font-size: 20px;
              }
            }
          }
        }
        .noDom {
          flex: 4;
          background: #f1f0f0;
          margin-left: 20px;
        }
      }
    }
    .right {
      flex: 4;
      margin-left: 20px;
      .order {
        height: 160px;
        background: #fff;
        border-radius: 12px;
        .studentLook {
          flex: 4;
          height: 160px;
          background: #fff;
          margin-left: 30px;
          border-radius: 12px;
          text-align: center;
          .orderMes {
            width: 120px;
            height: 40px;
            border-radius: 8px;
            background-image: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
            margin-top: 20px;
            margin-left: -30px;
          }
          .studentView {
            width: 120px;
            height: 40px;
            border-radius: 8px;
            margin-top: 20px;
            margin-left: -30px;
            background: #f8f8f8;
            color: #000;
            border: none;
            .logo {
              width: 20px;
              height: 20px;
              margin-top: -4px;
              margin-right: 8px;
              margin-left: -10px;
            }
          }
        }
      }
      .history {
        height: 160px;
        margin-top: 20px;
        background: #fff;
        border-radius: 12px;
        text-align: center;
        .resources {
          width: 120px;
          height: 48px;
          margin-top: 20px;
          color: #22c190;
          font-size: 18px;
        }
        .classes {
          width: 120px;
          height: 48px;
          margin-top: 20px;
          color: @primary-color;
          font-size: 18px;
        }
      }
    }
  }
  .fun {
    margin: 20px 0px 20px 0px;
    .add {
      width: 120px;
      height: 40px;
      color: #a3af90;
      font-size: 16px;
    }
  }
}
.dalog,
.editdalog {
  padding: 25px;
  .mess {
    width: 1000px;
    height: 150px;
    margin-top: 15px;
    border: 1px solid #e1d9c2;
    background-color: #f8f8f8;
    padding: 20px 30px 0px 30px;
    p {
      color: #000;
      letter-spacing: 0px;
      font-size: 16px;
      line-height: 32px;
    }
  }
  .uploadImg {
    margin-top: 20px;
    .upload {
      width: 100px;
      height: 30px;
      color: #a3af90;
      margin-right: 20px;
    }
  }
}
.sureButton {
  width: 120px;
  height: 30px;
  background: @primary-color;
  color: #fff;
  float: right;
}
/deep/.ant-upload-list-picture .ant-upload-list-item-error,
.ant-upload-list-picture-card .ant-upload-list-item-error {
  border-color: #fff;
}
.classNumber {
  min-height: 260px;
  .classTop {
    .classSelect {
      height: 40px;
      line-height: 40px;
    }
  }
  .classBot {
    height: 40px;
    line-height: 40px;
    margin-top: 10px;
    .cancelButton {
      width: 180px;
    }
    .classSureButton {
      width: 180px;
      background: @primary-color;
      color: #fff;
      margin-left: 10px;
    }
  }
}
/deep/.ant-checkbox + span {
  font-size: 20px;
  color: #040506;
  font-size: 18px;
  font-family: PingFangSC-Regular;
  padding-left: 20px;
}
.caozuo {
  text-align: right;
  height: 60px;
  .edit {
    width: 120px;
    height: 40px;
    color: @primary-color;
    font-size: 16px;
    margin-right: 20px;
  }
  .delete {
    width: 120px;
    height: 40px;
    color: #db5647;
    font-size: 16px;
    margin-right: 20px;
  }
}
.view-mess{
  background: #f8f8f8;
  .view-detail{
    font-size: 18px;
    color: #333;
    margin-top: 2px;
    background: #fff;
    padding: 20px;
  }
}
</style>
